import script from "./Step4GafeteEnviado.vue?vue&type=script&setup=true&lang=js"
export * from "./Step4GafeteEnviado.vue?vue&type=script&setup=true&lang=js"

import "./Step4GafeteEnviado.vue?vue&type=style&index=0&id=01963dff&lang=css"

const __exports__ = script;

export default __exports__